export default {

  fillPricesCompare(state, payload) {
    state.prices.loaded = true
    state.prices.data = payload
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics/mutations.js